import { isRecargasPlan } from "@/lib/credits-plan";

export const FREE_TRIAL_PLAN_ID = "explora";

export const EXTRA_PACKS_SWITCH_KEY = "enable_extra_pack_purchases";
export const EXTRA_PACKS_SWITCH_BRAND = "flow";

export function canBuyExtraPacks(planId: string | null | undefined): boolean {
  return planId !== FREE_TRIAL_PLAN_ID && !isRecargasPlan(planId);
}

export function isExtraPacksSwitchOn(value: unknown): boolean {
  return typeof value === "string" && value.trim().toLowerCase() === "true";
}
